

$(document).ready(function () {



    if ($(window).width() <= 767) {
        $('#sshopify-section-template--17141761704017__image_with_link_only_LPYK3F .image_section_box').slick({
            dots: false,
            centerMode: true,

            arrows: false,
            infinite: true,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            infinite: true,
            cssEase: 'linear',

            slidesToScroll: 1
        });



    }

    // two image section
    if ($(window).width() <= 767) {
        $('div#shopify-section-template--17141761704017__image_with_link_only_Lc9wWJ .image_section_box').slick({
            dots: false,
            centerMode: true,

            arrows: false,
            infinite: true,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            infinite: true,
            cssEase: 'linear',

            slidesToScroll: 1
        });



    }
    // home category
    $('.home_cat_section_inr').slick({
        dots: false,


        arrows: true,
        prevArrow: $('.prev_cat'),
        nextArrow: $('.next_cat'),
        infinite: true,
        slidesToShow: 8,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        cssEase: 'linear',

        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    centerMode: true,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }

        ]

    });
    // house of vastranand

    $('.home_house_of_vastranand_box_cat_section_inr').slick({
        dots: false,
        prevArrow: $('.prev_cat_v'),
        nextArrow: $('.next_cat_v'),


        infinite: true,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        cssEase: 'linear',

        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1441,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    });



    $('.fi_img_box_main_inr').slick({
        dots: false,
        slidesToShow: 3,
        autoplay: true,
        arrows: true,
        autoplaySpeed: 2000,
        infinite: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 481,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    });




});